import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/fenxiang.png';

const _withScopeId = n => (_pushScopeId("data-v-07229c72"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "vip"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = {
  class: "user-vip"
};
const _hoisted_4 = {
  class: "user-img"
};
const _hoisted_5 = {
  class: "text"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1,
  class: "tgsj"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 推广奖励时间：");

const _hoisted_9 = {
  key: 2
};
const _hoisted_10 = {
  key: 3,
  class: "time"
};

const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 优惠剩余时间：");

const _hoisted_12 = {
  class: "cont"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_14 = [_hoisted_13];

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, [/*#__PURE__*/_createTextVNode("VIP会员 "), /*#__PURE__*/_createElementVNode("span", null, "手机/平板/电脑多端通用")], -1));

const _hoisted_16 = {
  class: "vip-list"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
  class: "name"
};
const _hoisted_19 = {
  class: "money-box"
};

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fh"
}, "￥", -1));

const _hoisted_21 = {
  class: "money"
};
const _hoisted_22 = {
  key: 0,
  class: "hj"
};
const _hoisted_23 = {
  class: "money"
};

const _hoisted_24 = /*#__PURE__*/_createTextVNode("合计：");

const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "￥", -1));

const _hoisted_26 = {
  class: "num"
};
const _hoisted_27 = {
  class: "pay_content"
};

const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "选择支付方式", -1));

const _hoisted_29 = {
  class: "money"
};

const _hoisted_30 = /*#__PURE__*/_createTextVNode(" ￥ ");

const _hoisted_31 = {
  class: "pay_box"
};
const _hoisted_32 = {
  class: "pay_title"
};
const _hoisted_33 = {
  class: "pay_list_cont"
};
const _hoisted_34 = ["onClick"];
const _hoisted_35 = ["src"];
const _hoisted_36 = {
  class: "message"
};

const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "提示", -1));

const _hoisted_38 = {
  class: "text"
};
const _hoisted_39 = {
  class: "btns"
};
import { ref, computed } from "vue";
import router from "@/router";
import { getGlobalProperties, getMyDate } from "@/assets/js/utils.js";
import { useStore } from "vuex";
import { Toast } from "vant";
export default {
  __name: 'vip copy',

  setup(__props) {
    const {
      depositApi,
      payConfigApi,
      depositPayApi
    } = getGlobalProperties().$api;
    const store = useStore();
    const activeData = ref({});
    const vipList = ref([]);
    const payList = ref([]);
    const showPay = ref(false);
    const show = ref(false);
    const pagePatList = ref([]);
    const payObj = ref({});
    const payActiveIndex = ref("0-0");
    const combo_id = ref("");
    const money = ref("");
    const time = computed(() => {
      return 24 * 60 * 60 * 1000 - (new Date().getTime() - store.state.userInfo?.create_time * 1000);
    });
    const isDiscount = computed(() => {
      return time.value > 0;
    });

    const getdepositList = () => {
      depositApi("", "get").then(res => {
        if (res.code === 0) {
          vipList.value = res.data.vip_config;
        } else {
          Toast(res.message);
        }
      });
    };

    getdepositList();

    const itemClick = item => {
      activeData.value = item;
    };

    const onFinish = () => {
      location.href = "/vip";
    };

    const getPayConfig = () => {
      payConfigApi("", "get").then(res => {
        if (res.code === 0) {
          payList.value = res.data.filter(item => item.pay_list && item.pay_list.length);
        }
      });
    };

    getPayConfig();

    const isPayFun = money => {
      money = Number(money);
      pagePatList.value = [];

      if (payList.value) {
        payList.value.forEach(item => {
          item.pay_list.forEach(elem => {
            if (elem.money_type === 2) {
              if (elem.money.includes(money)) {
                pagePatList.value.push(item);
              }
            } else if (elem.money_type === 1) {
              if (money >= elem.min && money <= elem.max) {
                pagePatList.value.push(item);
              }
            }
          });
        });
      }

      if (pagePatList.value.length) {
        payObj.value = pagePatList.value[0].pay_list[0];
        payObj.value.channel_type = pagePatList.value[0].channel_type;
        payActiveIndex.value = "0-0";
        return true;
      } else {
        return false;
      }
    };

    const payItemClick = (item, elem, index, ind) => {
      payActiveIndex.value = index + "-" + ind;
      payObj.value = elem;
      payObj.value.channel_type = item.channel_type;
    };

    const submit = () => {
      if (!activeData.value.id) return;
      show.value = true;
    };

    const okBtn = () => {
      if (!store.state.userInfo.username) {
        router.push("/login");
        return;
      }

      combo_id.value = activeData.value.id;

      if (isPayFun(isDiscount.value ? activeData.value.real_money : activeData.value.money)) {
        money.value = isDiscount.value ? activeData.value.real_money : activeData.value.money;
        showPay.value = true;
      } else {
        Toast("无可用充值渠道，请选择其它金额或稍后重试");
      }

      show.value = false;
    };

    const depositPay = () => {
      const params = {
        amount: money.value,
        channel: payObj.value.channel,
        code: payObj.value.code,
        group_id: payObj.value.group_id,
        channel_type: payObj.value.channel_type || 3
      };
      params.combo_id = combo_id.value;
      depositPayApi(params).then(res => {
        if (res.code === 0) {
          showPay.value = false;
          location.href = res.data.url;
        } else {
          Toast(res.message);
        }
      });
    };

    const toDetails = () => {
      if (!store.state.userInfo.username) {
        router.push("/register");
        return;
      }

      store.commit("SET_LOGIN_POPUP", {
        show: true,
        type: "ShareFreeWatch"
      });
    };

    return (_ctx, _cache) => {
      const _component_my_image = _resolveComponent("my-image");

      const _component_van_count_down = _resolveComponent("van-count-down");

      const _component_van_popup = _resolveComponent("van-popup");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(), _createBlock(_component_my_image, {
        key: _unref(store).state.userInfo.top_image,
        url: _unref(store).state.userInfo.top_image
      }, null, 8, ["url"]))]), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", null, _toDisplayString(!_unref(store).state.userInfo.username ? "游客" : `会员${_unref(store).state.userInfo.package_name ? "(" + _unref(store).state.userInfo.package_name + ")" : "（普通会员）"}`), 1), _unref(store).state.userInfo.vip_expire !== '0' ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_unref(store).state.userInfo.is_vip !== 1 ? "您当前未开通VIP" : `会员到期时间：${_unref(store).state.userInfo.vip_expire}`), 1)) : _createCommentVNode("", true), _unref(store).state.userInfo.expire_time > 0 ? (_openBlock(), _createElementBlock("p", _hoisted_7, [_hoisted_8, _createVNode(_component_van_count_down, {
        time: _unref(store).state.userInfo.expire_time * 1000,
        format: "DD 天 HH 时 mm 分 ss 秒"
      }, null, 8, ["time"])])) : (_openBlock(), _createElementBlock("p", _hoisted_9, "推广奖励时间：0")), _unref(isDiscount) ? (_openBlock(), _createElementBlock("p", _hoisted_10, [_hoisted_11, _createVNode(_component_van_count_down, {
        onFinish: onFinish,
        time: _unref(time),
        format: "HH 时 mm 分 ss 秒"
      }, null, 8, ["time"])])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
        class: "fx-btn",
        onClick: toDetails
      }, "全民分享  免费看片"), _createElementVNode("div", {
        class: "img-fx",
        onClick: toDetails
      }, _hoisted_14), _hoisted_15, _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vipList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["item", activeData.value.id === item.id ? 'active' : '']),
          key: item.id,
          onClick: $event => itemClick(item)
        }, [_createElementVNode("p", _hoisted_18, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", null, [_createElementVNode("p", _hoisted_21, _toDisplayString(_unref(isDiscount) ? item.real_money : item.money), 1), _createElementVNode("p", {
          class: _normalizeClass(["money2", item.remark.indexOf('/天') > -1 ? '' : 'color'])
        }, _toDisplayString(item.remark), 3)])])], 10, _hoisted_17);
      }), 128))]), activeData.value.real_money ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("span", _hoisted_23, [_hoisted_24, _hoisted_25, _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(isDiscount) ? activeData.value.real_money : activeData.value.money), 1)]), _createElementVNode("span", {
        class: "btn",
        onClick: submit
      }, "立即支付")])) : _createCommentVNode("", true)]), _createVNode(_component_van_popup, {
        "overlay-class": "pay_overlay",
        show: showPay.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => showPay.value = $event),
        position: "bottom",
        round: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("p", _hoisted_29, [_hoisted_30, _createElementVNode("span", null, _toDisplayString(money.value), 1)]), _createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pagePatList.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "pay_list",
            key: index
          }, [_createElementVNode("p", _hoisted_32, _toDisplayString(item.channel_name), 1), _createElementVNode("div", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pay_list, (elem, ind) => {
            return _openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["pay_list_item", payActiveIndex.value === index + '-' + ind ? 'active' : '']),
              key: index + ind,
              onClick: $event => payItemClick(item, elem, index, ind)
            }, [_createElementVNode("img", {
              src: item.channel_image,
              alt: ""
            }, null, 8, _hoisted_35), _createTextVNode(_toDisplayString(elem.channel_name), 1)], 10, _hoisted_34);
          }), 128))])]);
        }), 128))]), _createElementVNode("div", {
          class: "user-public-btn",
          onClick: depositPay
        }, "确认充值")])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_popup, {
        show: show.value,
        "onUpdate:show": _cache[2] || (_cache[2] = $event => show.value = $event)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_36, [_hoisted_37, _createElementVNode("div", _hoisted_38, [_createTextVNode(" 确认要充值" + _toDisplayString(activeData.value.title) + "，花费", 1), _createElementVNode("span", null, "￥" + _toDisplayString(_unref(isDiscount) ? activeData.value.real_money : activeData.value.money), 1)]), _createElementVNode("div", _hoisted_39, [_createElementVNode("span", {
          class: "qd",
          onClick: okBtn
        }, "确定"), _createElementVNode("span", {
          class: "qx",
          onClick: _cache[1] || (_cache[1] = $event => show.value = false)
        }, "取消")])])]),
        _: 1
      }, 8, ["show"])]);
    };
  }

};